import { useHistory } from 'react-router';

import { PATHS } from '.';
import { ReactComponent as ClueyPlusLogo } from '../../../../assets/icons/cluey-plus-logo.svg';
import RightColumn from '../RightColumn';
import TwoColumnLayout from '../TwoColumnLayout';
import { useReviewDetailsStore } from './SignUpReviewDetailsPage';
import { StudentEntryForm } from './SignUpStudentDetails';

const Students = ({ students }: { students: StudentEntryForm[] }) => {
  // case 1: students.length === 1, i.e. Kerri
  if (students?.length === 1) {
    return <span className="font-bold">{students[0].firstName}.</span>;
  }
  // case 2: students.length === 2
  if (students?.length === 2) {
    return (
      <>
        <span className="font-bold">{students[0].firstName}</span>
        <span> and </span>
        <span className="font-bold">{students[1].firstName}.</span>
      </>
    );
  }
  // case 3: students.length > 2
  // must show all students name, separated by commas
  // last student should include "and", i.e. "James, Charley, and Olivia"
  const lastStudent = students[students.length - 1];
  const otherStudents = students.slice(0, -1);
  return (
    <span className="font-bold">
      {otherStudents.map((student) => student.firstName).join(', ')} and {lastStudent.firstName}.
    </span>
  );
};

const SignUpSuccessPage = () => {
  const history = useHistory();
  const { signUpUser, students } = useReviewDetailsStore();

  if (!signUpUser || !students) {
    history.replace(PATHS.STUDENT_DETAILS_PATH);
  }

  const renderLeftColumn = () => {
    return (
      <div className="ml-auto mr-auto box-content flex h-full max-w-[420px] flex-col px-5">
        <div className="mt-20">
          <div className="m-auto flex items-center justify-center">
            <ClueyPlusLogo className="h-[41px] w-[140px]" />
          </div>
        </div>
        <h2 className="my-5 text-center font-display text-4xl font-bold">Cluey+ free trial activated</h2>
        <div className="mt-6 text-center">
          <span className="mr-1">Your free trial starts now for</span>
          <Students students={students} />
        </div>
        <div className="mt-4 text-center">You'll receive a confirmation email with a link to Cluey+ soon.</div>
      </div>
    );
  };
  const renderRightColumn = () => {
    return <RightColumn step={5} />;
  };
  return <TwoColumnLayout renderLeftColumn={renderLeftColumn} renderRightColumn={renderRightColumn} />;
};

export default SignUpSuccessPage;
